import { Link as ChakraLink } from "@chakra-ui/react";
import { useRouter } from "next/router";

const Link = ({ children, href, ...props }) => {
  const { locale, defaultLocale } = useRouter();

  const resolvedHref =
    locale !== defaultLocale && href?.startsWith("/")
      ? `/${locale}${href}`
      : href;

  return (
    <ChakraLink color="primary" href={resolvedHref} {...props}>
      {children}
    </ChakraLink>
  );
};

export default Link;
